/* global window HTMLElement requestAnimationFrame */

class CookieBanner extends HTMLElement {

    constructor() {
        super();

        const categoriesButtonSelector = this.getAttribute('data-show-categories-button-selector');
        if (!categoriesButtonSelector) {
            throw new Error('The attribute "data-show-categories-button-selector" was not found but is required.');
        }

        this.categoriesButton = this.querySelector(categoriesButtonSelector);
        if (!(this.categoriesButton instanceof HTMLElement)) {
            throw new Error(`No HTML element with the selector "${categoriesButtonSelector}" found.`);
        }

        this.showCategoriesClassName = this.getAttribute('data-show-categories-class-name');
        if (!this.showCategoriesClassName) {
            throw new Error('The attribute "data-show-categories-class-name" was not found but is required.');
        }
    }

    connectedCallback() {
        if (this.categoriesButton) {
            this.registerSelectButtonClickListener();
        }
    }

    registerSelectButtonClickListener() {
        this.categoriesButton.addEventListener('click', this.showCategories.bind(this));
    }

    showCategories() {
        requestAnimationFrame(() => this.classList.add(this.showCategoriesClassName));
    }

}

if (!window.customElements.get('cookie-banner')) {
    window.customElements.define('cookie-banner', CookieBanner);
}
